import moment from 'moment';
import _ from './lodash';
import { getStyleParams } from '../../commons/services/Wix';
import { badgesList } from '../../commons/badges';
import {
  weekdays,
  languages,
  timeFormats,
  dateFormats
} from '../../commons/services/static';

// Map params name in case we like to switch to storing a field in a different Wix style param
export const params = {
  language: 'language',
  firstDayOfWeek: 'firstDayOfWeek',
  timeFormat: 'timeFormat',
  dateFormat: 'dateFormat',
  timezone: 'timezone',
  selectedBadge: 'selectedBadge',
  linkToPageEnabled: 'linkToPageEnabled',
  modalEnabled: 'modalEnabled',
  animateEnabled: 'animateEnabled',
  noSublineEnabled: 'noSublineEnabled',

  badgeFirstColor: 'badgeFirstColor',
  badgeSecondColor: 'badgeSecondColor',
  badgeThirdColor: 'badgeThirdColor',

  modalBackgroundColor: 'modalBackgroundColor',
  modalNoteBackgroundColor: 'modalNoteBackgroundColor',
  modalNotesFont: 'modalNotesFont',
  modalNotesColor: 'modalNotesColor',
  modalHeadlineFont: 'modalHeadlineFont',
  modalHeadlineColor: 'modalHeadlineColor',
  modalWeekdaysFont: 'modalWeekdaysFont',
  modalWeekdaysColor: 'modalWeekdaysColor',
  modalTimeSlotsFont: 'modalTimeSlotsFont',
  modalTimeSlotsColor: 'modalTimeSlotsColor'
};

// Returns our internal data representation build from Wix style params,
// also sets defaults.
export function parseStyles(styles) {
  let timezone;
  const timezoneIdx = styles.numbers[params.timezone];

  if (!_.isUndefined(timezoneIdx)) {
    timezone = moment.tz.names()[timezoneIdx];
  } else {
    timezone = moment.tz.guess();
  }

  return {
    language: languages[styles.numbers[params.language] || 0],
    firstDayOfWeek: weekdays[styles.numbers[params.firstDayOfWeek] || 0],
    // If modal and link are enabled, modal has priority
    linkToPageEnabled: styles.booleans[params.linkToPageEnabled] || false,
    modalEnabled: params.modalEnabled in styles.booleans
      ? styles.booleans[params.modalEnabled]
      : true,
    animateEnabled: params.animateEnabled in styles.booleans
      ? styles.booleans[params.animateEnabled]
      : true,
    noSublineEnabled: params.noSublineEnabled in styles.booleans
      ? styles.booleans[params.noSublineEnabled]
      : false,
    timeFormat: timeFormats[styles.numbers[params.timeFormat] || 0],
    dateFormat: dateFormats[styles.numbers[params.dateFormat] || 0],
    timezone,
    selectedBadge: badgesList[styles.numbers[params.selectedBadge] || 0].id,

    badgeFirstColor: getColor(styles, params.badgeFirstColor),
    badgeSecondColor: getColor(styles, params.badgeSecondColor),
    badgeThirdColor: getColor(styles, params.badgeThirdColor),

    modalBackgroundColor: getColor(styles, params.modalBackgroundColor),
    modalNoteBackgroundColor: getColor(styles, params.modalNoteBackgroundColor),
    modalNotesFont: getFont(styles, params.modalNotesFont),
    modalNotesColor: getColor(styles, params.modalNotesColor),
    modalHeadlineFont: getFont(styles, params.modalHeadlineFont),
    modalHeadlineColor: getColor(styles, params.modalHeadlineColor),
    modalWeekdaysFont: getFont(styles, params.modalWeekdaysFont),
    modalWeekdaysColor: getColor(styles, params.modalWeekdaysColor),
    modalTimeSlotsFont: getFont(styles, params.modalTimeSlotsFont),
    modalTimeSlotsColor: getColor(styles, params.modalTimeSlotsColor),
    googleFontsCssUrl: styles.googleFontsCssUrl
  };
}

function getColor(styles, param) {
  return _.get(styles, ['colors', param, 'value'], '');
}

function getFont(styles, param) {
  return _.get(styles, ['fonts', param, 'value'], '');
}

// Async get styles in a parsed format from Wix
export function getStyles() {
  return getStyleParams().then(parseStyles);
}



// WEBPACK FOOTER //
// ./src/commons/services/styles.js